import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AuthenticationService } from "app/pages/login/authentication.service";
import { environment } from "environments/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthenticationService
  ) { }
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let clonedRequest = req.clone();

    if (this.isBackendUrl(req.url) || this.isEventsUrl(req.url)) {
      clonedRequest = req.clone({
        setHeaders: {
          Authorization: this.authService.getToken(),
          'Accept-Language': this.getAcceptLanguage(),
        }
      })
    }

    return next.handle(clonedRequest);
  }

  isBackendUrl(url: string) {
    return url.startsWith(environment.urlApi);
  }

  isEventsUrl(url: string) {
    return url.startsWith(environment.urlEvents);
  }

  getAcceptLanguage(): string {
    const langMap = { ptbr: 'pt-BR', en: 'en', es: 'es' };
    return langMap[localStorage.getItem('lang')] || 'pt-BR';
  }
}